import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const names = ['María', 'Camila', 'Valentina', 'Luciana', 'Sofía', 'Carolina', 'Daniela', 'Florencia', 'Julieta', 'Martina', 'Gabriela', 'Andrea', 'Paula', 'Natalia', 'Laura', 'Alejandra', 'Fernanda', 'Catalina', 'Mariana', 'Isabella', 'Renata', 'Agustina', 'Milagros', 'Rocío', 'Antonella', 'Guadalupe', 'Ximena', 'Paola', 'Lorena', 'Celeste'];
const cities = ['Buenos Aires, Argentina', 'Córdoba, Argentina', 'Rosario, Argentina', 'Mendoza, Argentina', 'Bogotá, Colombia', 'Medellín, Colombia', 'Ciudad de México, México', 'Guadalajara, México', 'Lima, Perú', 'Santiago, Chile', 'Montevideo, Uruguay', 'Quito, Ecuador', 'Asunción, Paraguay', 'San José, Costa Rica', 'Panamá, Panamá', 'La Paz, Bolivia', 'Caracas, Venezuela', 'Santo Domingo, Rep. Dominicana', 'Tucumán, Argentina', 'Mar del Plata, Argentina'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomMinutes(): number {
  return Math.floor(Math.random() * 25) + 2;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    minutes: 0
  });
  const showNotification = () => {
    setData({
      name: getRandomItem(names),
      city: getRandomItem(cities),
      minutes: getRandomMinutes()
    });
    setVisible(true);
    setTimeout(() => setVisible(false), 4000);
  };
  useEffect(() => {
    const initialDelay = setTimeout(() => {
      showNotification();
    }, 5000);
    const interval = setInterval(() => {
      showNotification();
    }, 15000 + Math.random() * 10000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  return <div className="fixed bottom-4 left-4 z-50 max-w-xs sm:max-w-sm" data-id="element-157">
      <AnimatePresence data-id="element-158">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="bg-white rounded-2xl shadow-2xl border border-deco-warm p-4 flex items-start gap-3" data-id="element-159">
            <div className="w-10 h-10 rounded-full bg-deco-terra/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-160">
              <ShoppingBag size={18} className="text-deco-terra" data-id="element-161" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-162">
              <p className="text-sm font-semibold text-deco-text leading-snug" data-id="element-163">
                {data.name} compró Falso Vitral Deco
              </p>
              <p className="text-xs text-deco-taupe mt-0.5" data-id="element-164">{data.city}</p>
              <p className="text-[11px] text-deco-muted mt-1" data-id="element-165">
                Hace {data.minutes} minutos
              </p>
            </div>
            <button onClick={() => setVisible(false)} className="text-deco-muted hover:text-deco-text transition-colors text-lg leading-none shrink-0 -mt-1" aria-label="Cerrar notificación" data-id="element-166">
              ×
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}